<template>
  <!-- DATETIME -->
  <div class="event-datetime-wrapper py-0 mt-1">
    <div class>
      <div class="mx-1">
        <span class="icon has-text-grey-dark is-small">
          <i class="mdi mdi-calendar-clock mdi-16px"></i>
        </span>

        <span
          class="has-text-weight-semibold is-size-14px has-text-grey-dark ml-half"
        >{{ $t('ui.selectDate') }}</span>
      </div>

      <!-- MULTIIPLE SHOWTIMES -->
      <div class="is-rail py-half is-size-13px">
        <!-- showtimes array -->
        <div
          class="is-white has-border date-card cursor-pointer"
          v-for="(date, key) in event.data.eventShowtimes"
          :key="date.id"
          :class="{ 'is-active': selectedDate === date}"
          @click.prevent="setSelectedDate(date, key)"
        >
          <!-- <span
            class="icon has-bg has-text-success has-background-white-ter is-bottom-right"
           
          >
            <i  v-if="selectedDate === date" class="mdi mdi-check mdi-16px"></i>
          </span> -->

          <time
            class="is-block has-text-weight-medium"
            :datetime="date.startTime | toHTMLDate"
          >{{ eventDateStartTime(date) }}</time>
          <time
            class="is-inline-block"
            :datetime="date.startTime | toHTMLDateTime"
          >{{ date.startTime | toTime }}</time> -
          <time
            class="is-inline-block"
            :datetime="date.endTime | toHTMLDateTime"
          >{{ date.endTime | toTime }}</time>
          <span class="is-block is-size-xs" style="margin-top: 8px">
            <!-- <span class="icon is-small">
              <i class="mdi mdi-ticket mdi-12px"></i>
            </span>-->
            {{ calcAvaliableTicketNumber(date) }} {{ $t('ui.avaliableTickets') }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- ./DATETIME -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedDate: {}
    };
  },
  mounted() {
    this.selectedDate = this.event.data.eventShowtimes[0];
  },
  methods: {
    eventDateStartTime(datetime) {
      let date = "";
      if (datetime.startTime.getDate() === datetime.endTime.getDate()) {
        date = `${datetime.startTime.getDate()}
            ${this.$t(`monthNames.${datetime.startTime.getMonth()}`)}, 
            ${this.$t(`dayNames.${datetime.startTime.getDay()}`)}`;
      } else {
        date = `${datetime.startTime.getDate()}
            ${this.$t(`monthNames.${datetime.startTime.getMonth()}`).slice(
              0,
              3
            )}, ${this.$t(`dayNames.${datetime.startTime.getDay()}`)} - 
            ${datetime.endTime.getDate()} ${this.$t(
          `monthNames.${datetime.endTime.getMonth()}`
        ).slice(0, 3)}, ${this.$t(`dayNames.${datetime.endTime.getDay()}`)}`;
      }

      return date;
    },
    calcAvaliableTicketNumber(date) {
      const total =
        parseInt(date.totalTicketNumber) -
        parseInt(date.soldTicketNumber) -
        parseInt(date.reservedTicketNumber);
      return total;
    },
    setSelectedDate(date, key) {
      console.log("select date", date, key);
      this.selectedDate = date;
      this.$emit("on-select-date", date, key);
    }
  }
};
</script>

<style>
</style>